import React from "react";
import FlightsTable from "./FlightsTable.jsx";

export default function Arrivals(props) {
  return <FlightsTable {...props} mode="ARRIVALS" />;
}
